$mol_text $mol_list
	uri_base \
	text \
	param \
	flow_tokens /
	block_text* \
	auto /
		<= auto_scroll null
	- \Blocks
	Paragraph* $mol_paragraph
		sub <= block_content* /
	Quote* $mol_text
		text <= quote_text* \
		auto_scroll null
		highlight <= highlight \
		uri_resolve* <= uri_resolve* \
		code_sidebar_showed <= code_sidebar_showed true
	List* $mol_text_list
		type <= list_type* \-
		text <= list_text* \
		highlight <= highlight \
		uri_resolve* <= uri_resolve* \
		code_sidebar_showed <= code_sidebar_showed true
	item_index* 0
	Header* $mol_text_header
		minimal_height 40
		level <= header_level* 1
		content <= block_content* /
		arg <= header_arg* *
	Pre* $mol_text_code
		text <= pre_text* \
		row_themes <= pre_themes* /string
		highlight <= highlight \
		uri_resolve* <= uri_resolve* \
		sidebar_showed <= code_sidebar_showed true
	Cut* $mol_view dom_name \hr
	- \Table
	Table* $mol_grid
		head_cells <= table_head_cells* /
		rows <= table_rows* /
	Table_row* $mol_grid_row
		cells <= table_cells* /
	Table_cell* $mol_text
		auto_scroll null
		text <= table_cell_text* \
		highlight <= highlight \
		uri_resolve* <= uri_resolve* \
		code_sidebar_showed <= code_sidebar_showed true
	- \Grid
	Grid* $mol_grid
		rows <= grid_rows* /
	Grid_row* $mol_grid_row
		cells <= grid_cells* /
	Grid_cell* $mol_text
		auto_scroll null
		text <= grid_cell_text* \
		highlight <= highlight \
		uri_resolve* <= uri_resolve* \
		code_sidebar_showed <= code_sidebar_showed true
	- \Lines
	String* $mol_dimmer
		dom_name \span
		needle <= highlight \
		haystack <= line_text* \
	Span* $mol_text_span
		dom_name \span
		type <= line_type* \
		sub <= line_content* /
	Code_line* $mol_text_code_line
		numb_showed false
		highlight <= highlight \
		text <= line_text* \
		uri_resolve* <= uri_resolve* \
		syntax <= code_syntax null
	Link* $mol_link_iconed
		uri <= link_uri* \
		content <= line_content* /
	Link_http* $mol_link_iconed
		uri <= link_uri* \
		content / <= link_host* \
	Embed* $mol_embed_any
		uri <= link_uri* \
		title <= line_text* \
	- \Spoilers
	Spoiler* $mol_expander
		label /
			<= Spoiler_label* $mol_text
				text <= spoiler_label* \
				highlight <= highlight \
				uri_resolve* <= uri_resolve* \
				code_sidebar_showed <= code_sidebar_showed true
		content /
			<= Spoiler_content* $mol_text
				text <= spoiler_content* \
				highlight <= highlight \
				uri_resolve* <= uri_resolve* \
				code_sidebar_showed <= code_sidebar_showed true

$mol_text_header $mol_paragraph
	level 1
	sub /
		<= Link $mol_link
			arg <= arg *
			hint @ \Permalink to this section
			sub <= content /

$mol_text_span $mol_paragraph
	dom_name \span
	attr *
		^
		mol_text_type <= type \
